export type ENVIRONMENT = "development" | "test" | "staging" | "production";

const HOSTNAME_TO_ENVIRONMENT: Record<string, ENVIRONMENT> = {
  "petra.roqua.nl": "production",
  "petra.roqua-staging.nl": "staging",
  "petra.roqua.eu": "development",
  localhost: "development",
};

export function getEnvironment(): ENVIRONMENT {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    const env = HOSTNAME_TO_ENVIRONMENT[hostname];

    if (env) {
      return env;
    }
  }

  // Fallback to production if no match is found, which has
  // the least chance of breaking production.
  return "production";
}

export const environment = getEnvironment();
